/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { CONTENT_BLOCK_COMPLEMENTARY_STYLE_SCHEME } from '././defs.js';
export { default as CustomElement } from '../../components/content-block/content-block.js';
import createReactCustomElementType from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = {
  complementaryStyleScheme: {
    attribute: 'complementary-style-scheme',
  },
};
export var propTypes = {
  /**
   * The style scheme for the complementary content.
   */
  complementaryStyleScheme: PropTypes.string,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-content-block'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
